// extracted by mini-css-extract-plugin
export default {"root":"classes_root__cCnpR","icon":"classes_icon__DPIYu"};